import { render, staticRenderFns } from "./GitMergeDialog.vue?vue&type=template&id=24d4d0f5"
import script from "./GitMergeDialog.vue?vue&type=script&lang=js"
export * from "./GitMergeDialog.vue?vue&type=script&lang=js"
import style0 from "./GitMergeDialog.vue?vue&type=style&index=0&id=24d4d0f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports